/*
 * Module for the benefit details tab of the DROP Benefit Summary screen
*/

rs.module("participant/drop/summary/benefitdetails",

    ["common/select-helper"],

    function (selectHelper) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls) {

            var form = $.js(jsSelectors.form);

            // on month change, reload net benefit info
            form.js(jsSelectors.monthSelect).change(_loadNetBenefitInfo);

            // on year change, reload pay period months and net benefit info
            form.js(jsSelectors.yearSelect).change(function () {

                var monthSelect = form.js(jsSelectors.monthSelect);
                var yearSelect = $(this);

                form.js(jsSelectors.loadingSpinner).show();

                selectHelper.getHelper(monthSelect).loadOptionsFrom(
                    backendUrls.getPayPeriodMonths,
                    {
                        selectedYear: yearSelect.val(),
                        selectedMonth: monthSelect.val()
                    },
                    {},
                    function () {

                        // after changing years and reloading months, select the first month available for the year
                        selectHelper.getHelper(monthSelect).selectIndex(0);

                        _loadNetBenefitInfo();
                    });
            });

            // show/hide status history on hover
            form.js(jsSelectors.statusHistory).hoverIntent({
                handlerOver: function (event) {
                    form.js(jsSelectors.statusHistoryPopup).show();
                },
                handlerOut: function (event) {
                    form.js(jsSelectors.statusHistoryPopup).hide();
                },
                hoverOutDelay: 400
            });

            //
            // Calc new net benefit and load gross to net section
            //
            function _loadNetBenefitInfo() {

                var monthSelect = form.js(jsSelectors.monthSelect);
                var yearSelect = form.js(jsSelectors.yearSelect);

                form.js(jsSelectors.loadingSpinner).show();

                $.get(
                    backendUrls.calcNetBenefit,
                    {
                        selectedYear: yearSelect.val(),
                        selectedMonth: monthSelect.val()

                    }).done(function (result) {
                        form.js(jsSelectors.grossToNet).html(result);

                        form.js(jsSelectors.loadingSpinner).hide();
                    });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);